import { Typography } from '@mui/material';
import { NewAppPermissionData } from '@Src/_basic/object/AppPermissionType';
import React from 'react';

interface Props {
  row: NewAppPermissionData;
}
export default function IdColumnFormatter(props: Props) {
  const { row } = props;
  return <Typography variant="inherit">{row.ids}</Typography>;
}
